import {createSelector} from 'reselect';

import type {NutshellState} from '../../../store';

import {getUIState} from '../../ui-selectors';

const getPeopleIqState = createSelector([getUIState], (uiState) => uiState.peopleIq);

export const getAccountId = (state: NutshellState) => {
    // default to empty string to avoid null/undefined issues when using this in hooks
    return getPeopleIqState(state).accountId || '';
};

export const getAccountName = (state: NutshellState) => {
    return getPeopleIqState(state).accountName;
};

export const getLeadId = (state: NutshellState) => {
    return getPeopleIqState(state).leadId;
};

export const getContacts = (state: NutshellState) => {
    return getPeopleIqState(state).contacts;
};

export const getHasDismissedForAccount = (state: NutshellState, accountId: string) => {
    const dismissedAccounts = getPeopleIqState(state).dismissedAccounts;

    return dismissedAccounts && dismissedAccounts.includes(accountId);
};
